import { DropdownOption } from '@/shared/components/dropdown/ui/types';

export type FieldType = 'phone' | 'dropdown' | 'textarea';

export interface Field {
  name: string;
  className?: string;
  label: string;
  required?: string;
  type?: FieldType;
  options?: DropdownOption[];
  value?: string;
}

const products = [
  { value: 'Databases', label: 'fieldsChoseProductOptionsDatabase' },
  { value: 'API', label: 'fieldsChoseProductOptionsApiSdk' },
  { value: 'VectorMaps', label: 'fieldsChoseProductOptionsVectorMaps' },
  { value: 'DoubleGisPro', label: 'fieldsChoseProductOptions2gisPro' },
  { value: 'Telemarketing', label: 'fieldsChoseProductOptionsTelemarketing' },
  { value: 'OnPremise', label: 'fieldsChoseProductOptionsOnPremise' },
  { value: 'DoubleGisLens', label: 'fieldsChoseProductOptions2gisLens' },
  { value: 'PrintedProducts', label: 'fieldsChoseProductOptionsPrintMaps' },
  {
    value: 'SpecialProjects',
    label: 'fieldsChoseProductOptionsCustomSolution',
  },
  { value: 'Other', label: 'fieldsChoseProductOptionsOther' },
];

export const standardFormFields: Field[] = [
  {
    name: 'name',
    label: 'fieldsName',
    className: '!w-full',
    required: 'fieldsNameError',
  },
  {
    name: 'city',
    label: 'fieldsCity',
    className: '!w-full',
  },
  {
    type: 'phone',
    name: 'phone',
    label: 'fieldsPhone',
    required: 'fieldsPhoneError',
  },
  {
    name: 'email',
    label: 'fieldsEmail',
    className: '!w-full',
    required: 'fieldsEmailError',
  },
  {
    name: 'company',
    label: 'fieldsCompany',
    className: '!w-full',
  },
  {
    type: 'dropdown',
    name: 'product',
    label: 'fieldsChoseProductLabel',
    className: '!w-full',
    required: 'product',
    options: products,
  },
  {
    type: 'textarea',
    name: 'purpose',
    label: 'fieldsDescription',
    className: 'col-span-2 max-sm:col-span-1',
  },
];

export const partnersFormFields: Field[] = [
  {
    name: 'name',
    label: 'fieldsName',
    className: '!w-full',
    required: 'fieldsNameError',
  },
  {
    name: 'site',
    label: 'fieldsSite',
    className: '!w-full',
    required: 'fieldsSiteError',
  },
  {
    type: 'phone',
    name: 'phone',
    label: 'fieldsPhone',
    required: 'fieldsPhoneError',
  },
  {
    name: 'company',
    label: 'fieldsCompanyPartners',
    className: '!w-full',
  },
  {
    name: 'email',
    label: 'fieldsEmail',
    className: '!w-full',
    required: 'fieldsEmailError',
  },
  {
    type: 'textarea',
    name: 'purpose',
    label: 'fieldsDescriptionPartners',
    className: 'col-span-2',
  },
  {
    name: 'city',
    label: 'city',
    value: 'НСК',
    className: '!hidden',
  },
  {
    name: 'product',
    label: 'product',
    value: 'Other',
    className: '!hidden',
  },
];
